import React from 'react';

// The "Confirm" chip beside a Size unconfirmed badge (owner/admin only; the
// caller decides). Hands its row back to onConfirm, which accepts the tier the
// row holds now: see utils/sizeConfirm.js. No modal.
//
// stopPropagation because the card header it sits in is itself clickable.
function SizeConfirmButton({ row, disabled, onConfirm }) {
  return (
    <button
      type="button"
      className="size-confirm-btn"
      disabled={disabled}
      onClick={(e) => {
        e.stopPropagation();
        onConfirm(row);
      }}
      title="Accept the size shown on this card"
    >
      Confirm
    </button>
  );
}

export default SizeConfirmButton;
